import React, { useState } from 'react';
import './AgentOutputView.css';

const AgentOutputView = ({ outputs }) => {
    const [expandedAgents, setExpandedAgents] = useState(new Set());

    if (!outputs || outputs.length === 0) {
        return (
            <div className="agent-output-view no-data">
                <p>No agent outputs available</p>
            </div>
        );
    }

    const toggleAgent = (agentName) => {
        const newExpanded = new Set(expandedAgents);
        if (newExpanded.has(agentName)) {
            newExpanded.delete(agentName);
        } else {
            newExpanded.add(agentName);
        }
        setExpandedAgents(newExpanded);
    };

    return (
        <div className="agent-output-view">
            <div className="agents-list">
                {outputs.map((output, idx) => {
                    const isExpanded = expandedAgents.has(output.agent_name || idx);
                    const agentName = output.agent_name || `Agent ${idx + 1}`;
                    const agentType = output.agent_type || 'unknown';

                    return (
                        <div key={output.agent_name || idx} className="agent-output-card">
                            <div
                                className="agent-header"
                                onClick={() => toggleAgent(output.agent_name || idx)}
                            >
                                <div className="agent-header-left">
                                    <span className="agent-name">{agentName}</span>
                                    <span className="agent-type-badge">{agentType}</span>
                                </div>
                                <div className="agent-header-right">
                                    {output.key_findings && output.key_findings.length > 0 && (
                                        <span className="findings-count">
                                            {output.key_findings.length} findings
                                        </span>
                                    )}
                                    <span className="expand-icon">{isExpanded ? '▼' : '▶'}</span>
                                </div>
                            </div>

                            {isExpanded && (
                                <div className="agent-content">
                                    {output.output_summary && (
                                        <div className="agent-summary">
                                            <h5>Summary</h5>
                                            <p>{output.output_summary}</p>
                                        </div>
                                    )}

                                    {output.key_findings && output.key_findings.length > 0 && (
                                        <div className="agent-findings">
                                            <h5>Key Findings</h5>
                                            <ul>
                                                {output.key_findings.map((finding, findingIdx) => (
                                                    <li key={findingIdx}>{finding}</li>
                                                ))}
                                            </ul>
                                        </div>
                                    )}

                                    {output.output_data && (
                                        <div className="agent-data">
                                            <h5>Full Output Data</h5>
                                            <details>
                                                <summary>View Raw Data</summary>
                                                <pre className="raw-data">
                                                    {JSON.stringify(output.output_data, null, 2)}
                                                </pre>
                                            </details>
                                        </div>
                                    )}
                                </div>
                            )}
                        </div>
                    );
                })}
            </div>
        </div>
    );
};

export default AgentOutputView;

